import React, { useEffect, useState } from "react";
import FileGraphPage from "./FileGraphPage";
import DataTrendPage from "./DataTrendPage";
import MappingPage from "./MappingPage";
import VideoPage from "./VideoPage";
import { useSelector, useDispatch } from "react-redux";
import { newTestFile, chatbotAction } from "../../Redux/Action/newfile-action";
import swal from "sweetalert";

import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import Dash from "./Dash";

function MainTrendPage() {
  const dispatch = useDispatch();

  const [myVar, setMyVar] = useState("Data");
  const [selectedMethod, setSelectedMethod] = useState("Hamed Rao Test");
  const [count, setCount] = useState(90);
  const [confidenceText, setConfidenceText] = useState("");
  const [clicks, setClick] = useState(null);
  const [overallclick, setoverallclick] = useState(null);

  const [showConfidenceText, setShowConfidenceText] = useState(false);
  const [runSuccessful, setRunSuccessful] = useState(false);
  const [file, setFile] = useState(null);
  const [preWhitening, setPreWhitening] = useState(true);
  const [bootstrap, setBootstrap] = useState(true);
  const [rerender, setRerender] = useState(false);

  const [sidebarVisible, setSidebarVisible] = useState(false);

  const [errors, setErrors] = useState({
    file: null,
  });

  const {
    success: successAdd,
    addfiledata,
    error: errorOfFile,
  } = useSelector((state) => state.newTextFileReducer);

  const {
    success: successChatbot,
    chatbotdata,
    error: errorOfChatbot,
  } = useSelector((state) => state.chatbotReducer);

  const [inputMessage, setInputMessage] = useState("");
  const [messages, setMessages] = useState([
    {
      text: "👋 Welcome! I'm your AI assistant here to help you analyze and understand your data. How can I assist you today?",
      isUser: false,
    },
  ]);

  const [isTyping, setIsTyping] = useState(false);
  const [selectedModel, setSelectedModel] = useState("r1-1776");

  const [selectedFiles, setSelectedFiles] = useState([]);

  // Load the initial shared location from localStorage if available, or use default
  const [sharedLocation, setSharedLocation] = useState(() => {
    const savedLocation = localStorage.getItem("sharedLocation");
    return savedLocation
      ? JSON.parse(savedLocation)
      : {
          label: "New York City",
          coordinates: [-74.006, 40.7128],
          placeDetails: null,
        };
  });

  // Save shared location to localStorage whenever it changes
  useEffect(() => {
    if (sharedLocation) {
      localStorage.setItem("sharedLocation", JSON.stringify(sharedLocation));
    }
  }, [sharedLocation]);

  const onDrop = (acceptedFiles) => {
    const acceptedFile = acceptedFiles[0];
    const fileType = acceptedFile.type;
    const validFileType = fileType === "text/plain" || fileType === "text/csv";

    if (validFileType) {
      setFile(acceptedFile);
      setErrors({ ...errors, file: null });
    } else {
      setErrors({ ...errors, file: "File must be in .txt format" });
    }
  };

  function incrementCount() {
    if (count === 90) {
      setCount(95);
      setConfidenceText("1 in 20 reported trends are false");
    } else if (count === 95) {
      setCount(99);
      setConfidenceText("1 in 100 reported trends are false");
    }
    setShowConfidenceText(true);
  }

  function decrementCount() {
    if (count === 95) {
      setCount(90);
      setConfidenceText("1 in 10 reported trends are false");
    } else if (count === 99) {
      setCount(95);
      setConfidenceText("1 in 20 reported trends are false");
    }
    setShowConfidenceText(true);
  }

  const validateSubmit = (e) => {
    e.preventDefault();

    const tempErrors = {
      file: !file && "Please select a file",
    };
    setErrors(tempErrors);
    if (Object.values(tempErrors).filter((value) => value).length) {
      return;
    }

    handleSubmit();
    setFile(null);
  };

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("txt_file", file);
    formData.append("confidence", count);

    setRerender(true);

    setRunSuccessful(true);
    dispatch(newTestFile(formData));
    // localStorage.setItem('datascreen', JSON.stringify({ "datapage": { clicks, selectedMethod, preWhitening, bootstrap, count } }));

    const existingData = JSON.parse(localStorage.getItem("datascreen")) || {
      datapage: [],
    };
    const newDatapage = {
      clicks,
      selectedMethod,
      preWhitening,
      bootstrap,
      confidence: count,
    };
    existingData.datapage.push(newDatapage);

    // Store the updated data back into local storage
    localStorage.setItem("datascreen", JSON.stringify(existingData));
  };

  useEffect(() => {
    if (successAdd && rerender) {
      setMyVar("Analysis");
      setClick(null);
    }
    if (errorOfFile && rerender) {
      swal({
        title: "",
        text: errorOfFile,
        className: "successAlert",
        icon: "/smallMN.png",
        buttons: false,
        timer: 3000,
      });
    }
  }, [successAdd, errorOfFile]);

  const trackClick = (e) => {
    e.preventDefault();
    setClick(clicks + 1);
  };
  const overallClick = () => {
    setoverallclick(overallclick + 1);
    localStorage.setItem("overallclick", JSON.stringify(overallclick));
  };

  const handleFileChange = (e) => {
    setSelectedFiles(Array.from(e.target.files));
  };

  const handleSendMessage = async () => {
    if (!inputMessage.trim() && selectedFiles.length === 0) return;

    // Add user message to chat
    setMessages((prev) => [...prev, { text: inputMessage, isUser: true }]);
    const userMessage = inputMessage;
    setInputMessage("");
    setIsTyping(true);

    const formdata = new FormData();
    formdata.append("message", userMessage);

    // Append each selected file to formdata
    selectedFiles.forEach((file) => {
      formdata.append("files", file);
    });

    // Clear selected files after appending
    setSelectedFiles([]);

    try {
      const response = await dispatch(chatbotAction(formdata));

      console.log("response", response);

      // Extract the response text from the response object
      const botMessage = response || "Sorry, I couldn't process that.";

      setMessages((prev) => [...prev, { text: botMessage, isUser: false }]);
    } catch (error) {
      console.error("Error sending message:", error);
      setMessages((prev) => [
        ...prev,
        {
          text: "Sorry, there was an error processing your message.",
          isUser: false,
        },
      ]);
    }

    setIsTyping(false);
  };

  // Add useEffect to handle chatbot response
  useEffect(() => {
    if (successChatbot && chatbotdata && chatbotdata.response) {
      setMessages((prev) => [
        ...prev,
        { text: chatbotdata.response, isUser: false },
      ]);
      setIsTyping(false);
    }
    if (errorOfChatbot) {
      setMessages((prev) => [
        ...prev,
        {
          text: "Sorry, I encountered an error. Please try again.",
          isUser: false,
        },
      ]);
      setIsTyping(false);
    }
  }, [successChatbot, chatbotdata, errorOfChatbot]);

  const ModelSelector = () => (
    <div className="flex items-center justify-between p-2 bg-[#292727] border-t border-gray-700">
      <select
        value={selectedModel}
        onChange={(e) => setSelectedModel(e.target.value)}
        onClick={(e) => e.stopPropagation()}
        className="bg-[#3a3838] text-white px-3 py-1 rounded-md text-sm"
      >
        <option value="r1-1776">r1-1776</option>
        <option value="llama-3.1-sonar-large-128k-online">
          sonar-large-128k-online
        </option>
        <option value="sonar-reasoning-pro">sonar-reasoning-pro</option>
        <option value="sonar-reasoning">sonar-reasoning</option>
        <option value="sonar-pro">sonar-pro</option>
        <option value="sonar">sonar</option>
      </select>
    </div>
  );

  return (
    <div
      className="bg-[#cdcdcd63] relative min-h-screen"
      onClick={overallClick}
    >
      <div className="newgraph-div">
        <div className="graph-newdesign11">
          <div className="graph-down">
            <button
              onClick={() => {
                setMyVar("Data");
              }}
              className={
                myVar == "Data"
                  ? "all_graph_buttonnewdiv active"
                  : "all_graph_buttonnewdiv"
              }
            >
              Data
            </button>
          </div>
          <div className="graph-down">
            <button
              onClick={() => {
                setMyVar("Analysis");
              }}
              disabled={!runSuccessful}
              className={
                myVar == "Analysis"
                  ? "all_graph_buttonnewdiv active"
                  : "all_graph_buttonnewdiv"
              }
            >
              Analysis
            </button>
          </div>{" "}
          <div className="graph-down smallscreendiv">
            <button
              onClick={() => {
                setMyVar("Mapping");
              }}
              className={
                myVar == "Mapping"
                  ? "all_graph_buttonnewdiv active"
                  : "all_graph_buttonnewdiv"
              }
            >
              Mapping
            </button>
          </div>{" "}
          <div className="graph-down smallscreendiv">
            <button
              onClick={() => {
                setMyVar("Dash");
              }}
              className={
                myVar == "Dash"
                  ? "all_graph_buttonnewdiv active"
                  : "all_graph_buttonnewdiv"
              }
            >
              Dash
            </button>
          </div>{" "}
          <div className="graph-down smallscreendiv ">
            <button
              onClick={() => {
                setMyVar("Video");
              }}
              className={
                myVar == "Video"
                  ? "all_graph_buttonnewdiv active"
                  : "all_graph_buttonnewdiv"
              }
            >
              Video
            </button>
          </div>
        </div>
      </div>

      {/* Sidebar starts */}
      <Sidebar
        visible={sidebarVisible}
        position="right"
        onHide={() => setSidebarVisible(false)}
        className="w-[400px] p-0 z-[9999]"
        style={{ zIndex: 9999 }}
      >
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="headerai h-20 bg-[#292727] flex items-center gap-4">
            <span className="ml-3 h-12 w-12 flex items-center">
              <div className="relative">
                <i className="fas fa-robot robotai"></i>
                <span className="absolute top-0 left-[42px] w-3 h-3 bg-green-400 rounded-full"></span>
              </div>
            </span>
            <p className="text-center text-white text-3xl">AI Assistant</p>
          </div>

          {/* Messages */}
          <div className="flex-1 overflow-y-auto p-4 space-y-4">
            {messages.map((message, index) => (
              <div
                key={index}
                className={`flex ${
                  message.isUser ? "justify-end" : "justify-start"
                }`}
              >
                <div
                  className={`max-w-[80%] rounded-lg p-3 ${
                    message.isUser
                      ? "bg-blue-500 text-white rounded-br-none"
                      : "bg-gray-200 text-gray-800 rounded-bl-none"
                  }`}
                >
                  {message.text}
                </div>
              </div>
            ))}
            {isTyping && (
              <div className="flex justify-start">
                <div className="bg-gray-200 text-gray-800 rounded-lg rounded-bl-none p-3">
                  Typing...
                </div>
              </div>
            )}
          </div>

          {/* Model Selector */}
          <ModelSelector />

          {/* Input Area */}
          <div className="flex items-center gap-2 p-4 border-t border-gray-700">
            <label className="cursor-pointer">
              <input
                type="file"
                multiple
                onChange={handleFileChange}
                className="hidden"
              />
              <i className="fas fa-paperclip text-gray-400 hover:text-white transition-colors" />
            </label>

            <input
              type="text"
              value={inputMessage}
              onChange={(e) => setInputMessage(e.target.value)}
              placeholder="Type a message..."
              className="flex-1 bg-gray-700 text-white rounded-lg px-4 py-2 focus:outline-none"
            />

            {/* Show selected file names */}
            {selectedFiles.length > 0 && (
              <div className="absolute bottom-16 left-4 right-4 bg-gray-800 p-2 rounded">
                <p className="text-sm text-gray-400">Selected files:</p>
                {selectedFiles.map((file, index) => (
                  <p key={index} className="text-sm text-white truncate">
                    {file.name}
                  </p>
                ))}
              </div>
            )}

            <button
              onClick={handleSendMessage}
              disabled={!inputMessage.trim() && selectedFiles.length === 0}
              className="bg-blue-500 text-white rounded-lg px-4 py-2 hover:bg-blue-600 transition-colors disabled:opacity-50"
            >
              <i className="fas fa-paper-plane" />
            </button>
          </div>
        </div>
      </Sidebar>

      {/* Toggle Button */}
      {!sidebarVisible && (
        <button
          onClick={() => setSidebarVisible(true)}
          className="fixed right-4 top-1/2 transform -translate-y-1/2 bg-[#7867c1] text-white p-3 rounded-l-xl shadow-lg hover:bg-[#6656b0] transition-colors z-[9998]"
          style={{ zIndex: 9998 }}
        >
          <i className="fas fa-robot text-xl"></i>
        </button>
      )}

      {myVar === "Data" && (
        <div className="relative z-[1]">
          <DataTrendPage
            addfiledata={addfiledata}
            errorOfFile={errorOfFile}
            selectedMethod={selectedMethod}
            setSelectedMethod={setSelectedMethod}
            successAdd={successAdd}
            count={count}
            setCount={setCount}
            confidenceText={confidenceText}
            setConfidenceText={setConfidenceText}
            showConfidenceText={showConfidenceText}
            setShowConfidenceText={setShowConfidenceText}
            runSuccessful={runSuccessful}
            setRunSuccessful={setRunSuccessful}
            onDrop={onDrop}
            errors={errors}
            setErrors={setErrors}
            file={file}
            setFile={setFile}
            preWhitening={preWhitening}
            setPreWhitening={setPreWhitening}
            bootstrap={bootstrap}
            setBootstrap={setBootstrap}
            incrementCount={incrementCount}
            decrementCount={decrementCount}
            validateSubmit={validateSubmit}
            trackClick={trackClick}
            clicks={clicks}
            setClick={setClick}
            setMyVar={setMyVar}
            dispatch={dispatch}
            sharedLocation={sharedLocation}
            setSharedLocation={setSharedLocation}
          />
        </div>
      )}
      {myVar === "Analysis" && (
        <FileGraphPage
          addfiledata={addfiledata}
          errorOfFile={errorOfFile}
          selectedMethod={selectedMethod}
          setSelectedMethod={setSelectedMethod}
          successAdd={successAdd}
          count={count}
          setCount={setCount}
          showConfidenceText={showConfidenceText}
          setShowConfidenceText={setShowConfidenceText}
          runSuccessful={runSuccessful}
          setRunSuccessful={setRunSuccessful}
          onDrop={onDrop}
          errors={errors}
          file={file}
          preWhitening={preWhitening}
          setPreWhitening={setPreWhitening}
          bootstrap={bootstrap}
          setBootstrap={setBootstrap}
          incrementCount={incrementCount}
          decrementCount={decrementCount}
          validateSubmit={validateSubmit}
        />
      )}
      {myVar === "Mapping" && (
        <div className="relative z-[1]">
          <MappingPage
            sharedLocation={sharedLocation}
            setSharedLocation={setSharedLocation}
          />
        </div>
      )}
      {myVar === "Dash" && <Dash />}
      {myVar === "Video" && <VideoPage />}
    </div>
  );
}

export default MainTrendPage;
